// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mhba","title":"styles_title__Py7OV"};